<div class="overlay" (click)="toggleModal()"></div>
<div class="container flex-column m-0 p-0 d-flex">
  <div class="row g-0 m-0 p-4 justify-content-start borderb">
    <div class="col-md-11 ps-2 d-flex justify-content-start">
      <span class="popup-title">{{ "REMOTECOMMAND-CONNECTDISCONNECT" | translate }} {{ "DETAILS" | translate
        }}</span>
    </div>
    <div class="col-md-1 d-flex justify-content-end" (click)="toggleModal()">
      <svg-icon alt="Exit" class="exit" role="button" src="assets/device/exit.svg"></svg-icon>
    </div>
  </div>
  <div class="row g-0 m-0 body">
    <div class="row g-0 m-0">
      <div class="col-md-6 ps-2 d-flex justify-content-start">
        <span class="ps-4 pt-3 pb-3 item-name">{{
          "DEVICESETUP_ASSETTYPE" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="pt-3 pb-3 item-info">{{
          connDisconnGet.assetType ? connDisconnGet.assetType : "/"
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 ps-2 d-flex justify-content-start">
        <span class="ps-4 pt-3 pb-3 item-name">{{
          "DEVICESETUP_SERVICENAME" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="pt-3 pb-3 item-info">{{
          connDisconnGet.serviceName ? connDisconnGet.serviceName : "/"
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 ps-2 d-flex justify-content-start">
        <span class="ps-4 pt-3 pb-3 item-name">{{
          "DEVICESETUP_METERNO" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="pt-3 pb-3 item-info">{{
          connDisconnGet.meterNo ? connDisconnGet.meterNo : "/"
          }}</span>
      </div>
    </div>

    <div class="row g-0 m-0">
      <div class="col-md-6 ps-2 d-flex justify-content-start">
        <span class="ps-4 pt-3 pb-3 item-name">{{
          "STARTTIME" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="pt-3 pb-3 item-info">{{
          connDisconnGet.startTime ? (connDisconnGet.startTime | date: "dd MMM yyyy, h:mm a") : "/"
          }}</span>
      </div>
    </div>
    


    <div class="row g-0 m-0">
      <div class="col-md-6 ps-2 d-flex justify-content-start">
        <span class="ps-4 pt-3 pb-3 item-name">{{
          "INGESTIONTIME" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="pt-3 pb-3 item-info">{{
          connDisconnGet.endTime ? (connDisconnGet.endTime | date: "dd MMM yyyy, h:mm a") : "/"
          }}</span>
      </div>
    </div>
    
    <div class="row g-0 m-0">
      <div class="col-md-6 ps-2 d-flex justify-content-start">
        <span class="ps-4 pt-3 pb-3 item-name">{{
          "STATUS" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start align-items-center">
        <span class="item-info" [ngClass]="{
          'status-pending': connDisconnGet.status === 'Pending',
          'status-completed': connDisconnGet.status=== 'Success',
          'status-failed': connDisconnGet.status=== 'Failed',
          'status-fatal-error': connDisconnGet.status === 'ErrorOccured',
        }">{{
          connDisconnGet.status === 'ErrorOccured' ? ('FATAL_ERROR' | translate) : (connDisconnGet.status ? connDisconnGet.status : "/")
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 ps-2 d-flex justify-content-start">
        <span class="ps-4 pt-3 pb-3 item-name">{{
          "CONNDISCONNSETUP_ACTION" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start align-items-center">
        <span class="item-info status pt-1 pb-1 ps-2 pe-2" [ngClass]="{
          active: connDisconnGet.action === 'Connect',
          inactive: connDisconnGet.action=== 'Disconnect',
        }">{{
          connDisconnGet.action ? connDisconnGet.action : "/"
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="alert-description p-3">
        <span class="item-name d-block pb-2">{{
          "REASON" | translate
          }}</span>
        <span class="label-box-information"> {{connDisconnGet.reason}}</span>
      </div>
    </div>
  </div>
  <div class="row g-0 m-0 p-3 align-items-end bordert mt-auto">
    <div class="col-md-9 pt-2 pb-2 ps-2 d-flex justify-content-start" (click)="toggleModal()">
      <span role="button" class="item-name">{{
        "CLOSE_WINDOW" | translate
        }}</span>
    </div>
  </div>
</div>